import { FC } from 'react';
import styled from 'styled-components';
import ConversationPage from './conversation';
import { createGlobalStyle } from 'styled-components';

export const MessagingGlobalStyle = createGlobalStyle`
#page {
  height: 100vh;
  @media (max-width: 900px) {
    height: calc(100vh - 4rem);
  }
}
`;

const Container = styled.div`
  height: 100%;
`;

const MenteeMessaging: FC = () => {
  return (
    <Container>
      <MessagingGlobalStyle />
      <ConversationPage />
    </Container>
  );
};

export default MenteeMessaging;
